/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';


export const home_food_storage : {[key: string]: Array<[string, string]>} = {
    p_type: [
        ["FOOD_CONTAINERS", "D\u00f3zy, boxy a misky"],
        ["LUNCHBOXES", "Termota\u0161ky a termoobaly"],
        ["FOOD_STORAGE_BAGS", "S\u00e1\u010dky, f\u00f3lie a vreck\u00e1 na potraviny"],
        ["FOOD_CONSERVING", "Zav\u00e1ranie"],
        ["OTHER_FOOD_STORAGE", "In\u00e9"],
    ],
};
